const translations = {
  "en": {
    "Copy link": "Copy link",
    "Crypto News": "Crypto News",
    "Link copied successfully": "Link copied successfully",
    "Share to": "Share to",
    "Stock News": "Stock News",
    "Themes": "Themes"
  },
  "zh-tw": {
    "Copy link": "複製連結",
    "Crypto News": "幣圈新聞",
    "Link copied successfully": "連結複製成功",
    "Share to": "分享至",
    "Stock News": "股票新聞",
    "Themes": "主題"
  }
};

export default translations;
